import React, { createContext, useContext, useState, ReactNode } from 'react';
import { translations, Language } from '../locales/translations';
import { procurementTranslations } from '../locales/procurement';
import { procurementAdminTranslations } from '../locales/procurementAdmin';
import { trackingTranslations } from '../locales/tracking';

interface LanguageContextProps {
  language: Language;
  toggleLanguage: () => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<Language>('ru');

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'ru' ? 'kk' : 'ru'));
  };

  const t = (keyStr: string): string => {
    const keys = keyStr.split('.');
    let current: any = { ...translations[language], ...procurementTranslations[language], ...procurementAdminTranslations[language], ...trackingTranslations[language] };
    for (const key of keys) {
      if (!current || current[key] === undefined) {
        return keyStr;
      }
      current = current[key];
    }
    return current;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
